/**
 * The service figures a sales summary carries next to Quantity and Mass
 * Sold: how many per-service sales, and how many hours of per-hour services.
 * Each shows once the location has ever sold that kind of service, so a
 * business that never sold one sees its screens unchanged, and one that has
 * sees a quiet period as 0 rather than the figure disappearing. A server
 * older than these fields sends no flags, which reads as "never sold".
 */
export type ServiceSalesFigures = {
  totalServicesSold?: number;
  totalServiceHoursSold?: number;
  hasServiceSales?: boolean;
  hasServiceHourSales?: boolean;
};

type MaybeFigures = ServiceSalesFigures | null | undefined;

export const showsServicesSold = (figures: MaybeFigures): boolean =>
  figures?.hasServiceSales === true;

export const showsServiceHoursSold = (figures: MaybeFigures): boolean =>
  figures?.hasServiceHourSales === true;
